export default __webpack_public_path__ + "static/media/earth-spaceJaymantri1000.394a18dd.jpg";